import GenericDB from './generic-db'

export default class InvitesDB extends GenericDB {
  constructor() {
    super('invites')
  }

  // Here you can extend UserDB with custom methods
}
